<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="m17.073 14.285-3.388-3.08a.834.834 0 0 0-1.159.036l-1.994 2.05c-.48-.09-1.445-.392-2.438-1.383C7.1 10.915 6.799 9.947 6.71 9.47l2.05-1.995a.833.833 0 0 0 .035-1.159L5.716 2.929a.833.833 0 0 0-1.16-.072L2.75 4.407a.833.833 0 0 0-.242.541c-.013.209-.25 5.144 3.576 8.972 3.338 3.338 7.52 3.582 8.671 3.582.169 0 .272-.005.3-.007a.827.827 0 0 0 .54-.242l1.55-1.81a.831.831 0 0 0-.071-1.158Z"
    fill="#111"
    fill-opacity=".64"
  />
</svg>
